<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-11 14:51:43
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-07-15 16:11:39
 * @FilePath: \newpigboxmanger\src\views\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myhomebody">
    <el-container>
      <el-header>
        <div class="logoBox">四小碗后台运营管理平台</div>
        <div class="loginOutBox"><el-button icon="el-icon-user-solid" type="primary" size="mini" @click="loginOut">退出登录</el-button></div>
      </el-header>
      <el-container class="mainBox">
        <el-aside width="200px">
          <el-menu
            default-active="shop"
            class="el-menu-vertical-demo"
           
            background-color="#545c64"
            text-color="#fff"
            :router="true"
            active-text-color="#ffd04b"
          >
            <el-menu-item index="shop">
              <i class="el-icon-menu"></i>
              <span slot="title">店铺数据</span>
            </el-menu-item>
            <el-menu-item index="commodity">
              <i class="el-icon-document"></i>
              <span slot="title">商品管理</span>
            </el-menu-item>
            <el-menu-item index="order">
              <i class="el-icon-setting"></i>
              <span slot="title">订单管理</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
            <router-view style="width:100%;height:100%"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  methods:{
    loginOut(){
        this.$store.commit('loginOut')
        this.$router.push("/login")
    }
  }
};
</script>

<style>
.myhomebody {
  height: 100%;
  width: 100%;
  /* background-color: aqua; */
}
.el-container {
  height: 100%;
  width: 100%;
}
.el-header {
  width: 100%;
  height: 50px;
  background-color: #545c64;
  color: white;
  display: flex;
  justify-content: space-between;
  /* padding:0; */
  align-items: center;
}
.mainBox {
  height: calc(100vh - 50px);
  width: 100%;
  /* background-color: bisque; */
}
.el-aside {
  /* background-color: #0077ff; */
  background-color: #545c64;
  text-align: center;
  line-height: 200px;
}
.logoBox {
  width: 300px;
  height: 100%;
  /* background-color: #0077ff; */
  line-height: 50px;
  font-size: 20px;
}
.loginOutBox{
  height: 30px;
  width: 100px;
  /* background-color: aqua; */
}
</style>